/**
 * Domain event names written to the transactional outbox
 * (docs/architecture/02-high-level-architecture.md § events and outbox).
 * A module publishes these; other modules, webhooks and notifications react.
 */
export const EVENTS = {
    LEAD_CREATED: 'lead.created',
    LEAD_UPDATED: 'lead.updated',
    LEAD_ASSIGNED: 'lead.assigned',
    LEAD_STATUS_CHANGED: 'lead.status_changed',
    LEAD_CONVERTED: 'lead.converted',
    LEAD_MERGED: 'lead.merged',
    LEAD_DELETED: 'lead.deleted',
    CONTACT_CREATED: 'contact.created',
    COMPANY_CREATED: 'company.created',
    COMPANY_BECAME_CUSTOMER: 'company.became_customer',
    OPPORTUNITY_CREATED: 'opportunity.created',
    OPPORTUNITY_STAGE_CHANGED: 'opportunity.stage_changed',
    OPPORTUNITY_WON: 'opportunity.won',
    OPPORTUNITY_LOST: 'opportunity.lost',
    TASK_CREATED: 'task.created',
    TASK_COMPLETED: 'task.completed',
    TASK_OVERDUE: 'task.overdue',
    NOTE_MENTION: 'note.mention',
    USER_INVITED: 'user.invited',
    USER_DEACTIVATED: 'user.deactivated',
    AUTH_LOGIN_SUCCESS: 'auth.login.success',
    AUTH_LOGIN_FAILED: 'auth.login.failed',
    IMPORT_COMPLETED: 'import.completed',
    WEBHOOK_ENDPOINT_DISABLED: 'webhook.endpoint.disabled',
};
//# sourceMappingURL=events.js.map